import React, { useState } from 'react' // We are using useState to close and open sideBar
import './Header.css'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';



function Header() {
  const [burgerStatus, setBurgerStatus] = useState(false) // useState(false/0) this mean right now burger is closed (useState is closed)

  return (
    <div>
      {/* Header */}
      <div className="container">
        <a href="/#">
          <img src="/images/logo.svg" alt="" />
        </a>
        <div className="headerMenu">
          <a href="/#">Model S</a>
          <a href="/#">Model 3</a>
          <a href="/#">Model X</a>
          <a href="/#">Model Y</a>
          <a href="/#">Solar Roofs</a>
          <a href="/#">Solar Panels</a>
        </div>
        <div className="rightMenu">

          <MenuIcon className='hamburgerMenu' onClick={() => setBurgerStatus(true)} />
        </div>
        {/* <div className="burgerNav"  style={{transform : burgerStatus ? 'translateX(100%)' : 'translateX(0)'}}>  --> show side bar*/}
        <div className="burgerNav" style={{ transform: burgerStatus ? 'translateX(0)' : 'translateX(100%)', transition: '0.2s' }}>
          <div className="topSection">

            <div className="closeWrapper">
              <CloseIcon className="closeButton" onClick={() => setBurgerStatus(false)} />
            </div>
            <li><a href="/#1">Model S</a></li>
            <li><a href="/#">Model 3</a></li>
            <li><a href="/#">Model X</a></li>
            <li><a href="/#">Model Y</a></li>
            <li><a href="/#">Existing Inventory</a></li>
            <li><a href="/#">Use Inventory</a></li>
            <li><a href="/#">Trade-in</a></li>
            <li><a href="/#">Cybertruck</a></li>
            <li><a href="/#">Roadster</a></li>

          </div>
          
        </div>
      </div>
    </div>
  )
}

export default Header
